module.exports = __webpack_public_path__ + "img/timeline_mainevent-4.69c8f17d.jpg";